import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GdoDesktopRoutingModule } from './gdo-desktop-routing.module';
import { GdoProductComponent } from './gdo-product/gdo-product.component';
import { GdoProductModule } from './gdo-product/gdo-product.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { GdoVehicleComponent } from './gdo-vehicle/gdo-vehicle.component';
import { GdoVehicleModule } from './gdo-vehicle/gdo-vehicle.module';
import { GdoPaymentModule } from './gdo-payment/gdo-payment.module';
import { GdoPaymentComponent } from './gdo-payment/gdo-payment.component';


@NgModule({
  declarations: [
    /*Internal Modules of Gdo Desktop */
    GdoProductComponent,
    GdoVehicleComponent,
    GdoPaymentComponent,
  ],
  imports: [
    CommonModule,
    /*All Libraries Reffered in GDO*/
    MatGridListModule,
    /**Gdo Internal Routing*/
    GdoDesktopRoutingModule,

    /*Gdo Sub Components */
    GdoProductModule,
    GdoVehicleModule,
    GdoPaymentModule,
  ]
})
export class GdoDesktopModule { }
